module.exports = __webpack_public_path__ + "img/iconPrepage.ef9d00f4.svg";